import React from "react";
import { Modal, Btn } from "@/components/ui/kit";
import { printHtml, ticketHtml } from "@/lib/print";
import { toast } from "sonner";
import { Printer } from "lucide-react";

export const TicketModal = ({ sale, settings, onClose }) => {
  const html = sale ? ticketHtml(sale, settings) : "";
  const print = () => { if (!printHtml("Ticket", html)) toast.error("Permití ventanas emergentes para imprimir"); };
  return (
    <Modal open={!!sale} onClose={onClose} title="Venta registrada · Ticket" top>
      {sale && (
        <div className="space-y-4">
          <div className="mx-auto max-w-[300px] bg-white text-black rounded-md p-4 font-mono text-xs shadow-inner [&_.row]:flex [&_.row]:justify-between [&_.b]:font-bold [&_h1]:text-base [&_h1]:text-center [&_.c]:text-center [&_hr]:my-1.5 [&_hr]:border-dashed [&_hr]:border-black [&_.big]:text-sm [&_.muted]:text-[10px]"
            data-testid="ticket-preview" dangerouslySetInnerHTML={{ __html: html }} />
          <div className="flex gap-2">
            <Btn variant="outline" onClick={onClose} className="flex-1" data-testid="ticket-close">Nueva venta</Btn>
            <Btn onClick={print} className="flex-1" data-testid="ticket-print"><Printer className="w-4 h-4" /> Imprimir</Btn>
          </div>
        </div>
      )}
    </Modal>
  );
};
